import React, { useMemo, useState } from "react";
import { createPortal } from "react-dom";
import { Image } from "antd";
import { resolveAppMediaUrl } from "../../utils/resolveAppMediaUrl";
import {
  parseCsBroadcastContent,
  resolveCsBroadcastImageUrls,
  truncateCsBroadcastBody,
} from "./csBroadcastMessage";

const CS_BROADCAST_IMAGE_PREVIEW_GROUP = {
  destroyOnClose: true,
  zIndex: 2000,
  rootClassName: "space-cs-broadcast-image-preview",
  maskClosable: true,
  styles: {
    mask: {
      backgroundColor: "rgba(0, 0, 0, 0.65)",
    },
  },
};

const CS_BROADCAST_IMAGE_THUMB_PREVIEW = {
  mask: false,
};

function CsBroadcastSheetImages(props: { urls: string[] }) {
  const { urls } = props;
  if (urls.length === 0) return null;

  if (urls.length === 1) {
    return (
      <div className="space-cs-broadcast-sheet-images space-cs-broadcast-sheet-images--single">
        <Image.PreviewGroup preview={CS_BROADCAST_IMAGE_PREVIEW_GROUP}>
          <Image
            src={urls[0]}
            alt=""
            className="space-cs-broadcast-sheet-image"
            preview={CS_BROADCAST_IMAGE_THUMB_PREVIEW}
          />
        </Image.PreviewGroup>
      </div>
    );
  }

  return (
    <div className="space-cs-broadcast-sheet-images space-cs-broadcast-sheet-images--multi">
      <Image.PreviewGroup preview={CS_BROADCAST_IMAGE_PREVIEW_GROUP}>
        {urls.map((url, idx) => (
          <div key={`${idx}-${url}`} className="space-cs-broadcast-sheet-image-cell">
            <Image src={url} alt="" preview={CS_BROADCAST_IMAGE_THUMB_PREVIEW} />
          </div>
        ))}
      </Image.PreviewGroup>
    </div>
  );
}

export const CsBroadcastMessageCard: React.FC<{ content: string }> = ({ content }) => {
  const payload = useMemo(() => parseCsBroadcastContent(content), [content]);
  const [open, setOpen] = useState(false);

  if (!payload) {
    return <span>[群发通知]</span>;
  }

  const imageUrls = resolveCsBroadcastImageUrls(payload)
    .map((u) => resolveAppMediaUrl(u) ?? u)
    .filter(Boolean);
  const coverUrl = imageUrls[0] ?? "";
  const previewBody = truncateCsBroadcastBody(payload.body);

  const sheet = (
    <div
      className={`space-cs-broadcast-sheet-mask${open ? " space-cs-broadcast-sheet-mask--open" : ""}`}
      onClick={() => setOpen(false)}
    >
      <div className="space-cs-broadcast-sheet" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="space-cs-broadcast-sheet-head">
          <button type="button" className="space-cs-broadcast-sheet-close" onClick={() => setOpen(false)}>
            关闭
          </button>
        </div>
        <div className="space-cs-broadcast-sheet-body">
          {payload.title ? <div className="space-cs-broadcast-sheet-title">{payload.title}</div> : null}
          {payload.body ? <div className="space-cs-broadcast-sheet-text">{payload.body}</div> : null}
          <CsBroadcastSheetImages urls={imageUrls} />
        </div>
      </div>
    </div>
  );

  return (
    <>
      <button type="button" className="space-cs-broadcast-card" onClick={() => setOpen(true)}>
        {coverUrl ? <img src={coverUrl} alt="" className="space-cs-broadcast-card-image" /> : null}
        <div className="space-cs-broadcast-card-main">
          <div className="space-cs-broadcast-card-title">{payload.title}</div>
          <div className="space-cs-broadcast-card-body">{previewBody}</div>
        </div>
      </button>
      {createPortal(sheet, document.body)}
    </>
  );
};

export default CsBroadcastMessageCard;
